<template>
  <div class="animated fadeIn">
    <b-button
      type="button"
      size="sm"
      variant="primary"
      v-if="null !== membership.id"
      v-on:click="onBtnClick"
    ><i class="fa fa-window-close"></i> View
    </b-button>
  </div>
</template>
<script>
    import {Membership} from "../../../models/Membership"
    import router from "../../../router";

    export default {
        name: 'membership-view-button',
        props: {
            membership: {
                type: Object,
                default: new Membership(),
            },
        },
        methods: {
            onBtnClick() {
                router.push({name: 'member', params: {memberId: this.membership.id}})
            }
        },
    }
</script>
